import { useEffect, useState } from 'react';
import type { AutocompleteOption } from 'shared/search/types';
import type { Filters } from '@/domain';
import { dateOrNull, populateDestination } from '../utils/searchUtils';

export const useSearchFormState = (filters: Filters) => {
    const [fromDate, setFromDate] = useState(dateOrNull(filters.booking_from ?? ''));
    const [toDate, setToDate] = useState(dateOrNull(filters.booking_to ?? ''));
    const [destination, setDestination] = useState<AutocompleteOption | null>(populateDestination(filters));
    const [bedrooms, setBedrooms] = useState(Number(filters.no_of_bedrooms_from) || 0);
    const [beds, setBeds] = useState(Number(filters.no_of_beds_from) || 0);

    useEffect(() => {
        setFromDate(dateOrNull(filters.booking_from ?? ''));
        setToDate(dateOrNull(filters.booking_to ?? ''));
        setDestination(populateDestination(filters));
        setBedrooms(Number(filters.no_of_bedrooms_from) || 0);
        setBeds(Number(filters.no_of_beds_from) || 0);
    }, [filters]);

    return {
        fromDate,
        setFromDate,
        toDate,
        setToDate,
        destination,
        setDestination,
        bedrooms,
        setBedrooms,
        beds,
        setBeds,
    };
};
